import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from 'app/commons/items.service';

@Injectable({
    providedIn: 'root'
})
export class RolesService extends ItemsService{


    constructor(public http2: HttpClient) {
        super(http2);
    }
    
    getServiceName(){
        return 'role';
    }
    

    getUsers() {
        return this.http2.get<any>(ItemsService.API_URL+'user')
            .toPromise()
            .then(res => <any[]> res);
    }

}
